<template>
  <component :is="groupData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="groupData === undefined">
      <h4 class="alert-heading">
       {{ $t('Error fetching group data')}}
      </h4>
      <div class="alert-body">
        {{ $t('No group found with this group id. Check')}}
        <b-link class="alert-link" :to="{ name: 'groups_index'}">
          {{ $t('Groups List')}}
        </b-link>
        {{ $t('for other groups.')}}
      </div>
    </b-alert>

    <div class="loading_page" v-if="requestStatus">
      <orbit-spinner
          :animation-duration="1000"
          :size="100"
          :color="'#0e96b1'"
      />
    </div>

    <!-- Form -->
    <b-form v-if="groupData" @submit.prevent="submit">

      <!-- Name ar -->
      <b-form-group :label="$t('Arabic Name')" label-for="ar_name">
        <b-form-input
            id="ar_name"
            v-model="groupData.ar_name"
            autofocus
            :state="errors && ('ar_name' in errors) ? false : null"
            trim
            autocomplete="off"
            :placeholder="$t('Arabic Name')"
        />

        <b-form-invalid-feedback :state="errors && ('ar_name' in errors) ? false : null">
          {{ errors && ('ar_name' in errors) ? $t(errors.ar_name[0]) : null }}
        </b-form-invalid-feedback>

      </b-form-group>


      <!-- Name en -->
      <b-form-group :label="$t('English Name')" label-for="en_name">
        <b-form-input
            id="en_name"
            v-model="groupData.en_name"
            autofocus
            :state="errors && ('en_name' in errors) ? false : null"
            trim
            autocomplete="off"
            :placeholder="$t('English Name')"
        />

        <b-form-invalid-feedback :state="errors && ('en_name' in errors) ? false : null">
          {{ errors && ('en_name' in errors) ? $t(errors.en_name[0]) : null }}
        </b-form-invalid-feedback>

      </b-form-group>



      <!-- Form Actions -->
      <div class="d-flex mt-2">
        <b-button
            variant="primary"
            class="mr-2"
            type="submit">
          {{ $t('Save')}}
        </b-button>
      </div>
    </b-form>


  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BButton, BFormGroup, BFormInput, BForm, BFormTextarea,
    BFormInvalidFeedback
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import groupStoreModule from '@/views/modules/group/store/groupStoreModule'

import { OrbitSpinner } from 'epic-spinners'
import useGroupEdit from '@/views/modules/group/groups-edit/useGroupEdit'
import vSelect from 'vue-select'

export default {
  components: {
    BTab,
    BTabs,
    BFormTextarea,
    BFormInvalidFeedback,
    vSelect,
    BCard,
    BButton,
    BFormGroup,
    BFormInput,
    BForm,
    BAlert,
    OrbitSpinner,
    BLink,

  },
  setup(props, { root }) {

    const Group_APP_STORE_MODULE_NAME = 'app-group'

    if (!store.hasModule(Group_APP_STORE_MODULE_NAME)) store.registerModule(Group_APP_STORE_MODULE_NAME, groupStoreModule)

    onUnmounted(() => {
      if (store.hasModule(Group_APP_STORE_MODULE_NAME)) store.unregisterModule(Group_APP_STORE_MODULE_NAME)
    })

    const { submit, requestStatus, errors, groupData, fetchGroup } = useGroupEdit(root)

    fetchGroup()

    return {
      groupData,
      fetchGroup,
      requestStatus,
      errors,
      submit
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-type-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
